import { AppConfig } from './../app.config';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { CognitoCallback, CognitoUtil, LoggedInCallback } from './cognito.service';
import {
    AuthenticationDetails,
    CognitoUser,
    CognitoUserSession,
    ICognitoUserSessionData,
    CognitoAccessToken,
    CognitoIdToken,
    CognitoRefreshToken,
    ICognitoUserData
} from 'amazon-cognito-identity-js';
import { ServiceRegistry } from '../service/service-registry.service';

import * as AWS from 'aws-sdk';
import * as STS from 'aws-sdk/clients/sts';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { UserCredentials } from './user-credentials';
import { UserCredentialsCognito } from './user-credentials-cognito';
import { UserCredentialsLDAP } from './user-credentials-ldap';
import { JWTService } from './jwt.service';

@Injectable()
export class UserLoginService {
    username: string;


    constructor(
        // public cognitoUtil: CognitoUtil,
        public jwtService: JWTService,
        private serviceRegistry: ServiceRegistry,
        private appConfig: AppConfig,
        private http: HttpClient,
        private router: Router,
        @Inject(DOCUMENT) private document: any) {
    }

    authenticateWithCognitoUserPool(username: string, password: string, callback: CognitoCallback) {
        console.log('UserLoginService: starting the authentication');

        const authenticationData = {
            Username: username,
            Password: password,
        };
        const authenticationDetails = new AuthenticationDetails(authenticationData);


        const userCredentials = new UserCredentialsCognito(this.appConfig);

        const userData = {
            Username: username,
            Pool: userCredentials.getUserPool()
        };

        console.log('UserLoginService: Params set...Authenticating the user');
        const cognitoUser = new CognitoUser(userData);
        console.log('UserLoginService: config is ' + AWS.config);
        const self = this;

        cognitoUser.authenticateUser(authenticationDetails, {
            newPasswordRequired: function (userAttributes, requiredAttributes) {
                callback.cognitoCallback(`User needs to set password.`, null);
            },
            onSuccess: function (result) {
                const creds = userCredentials.buildCognitoCreds(result.getAccessToken().getJwtToken(), this.tenantInfo);
                this.jwtService.cognitoUtil.setCognitoCreds(creds);
                AWS.config.credentials = creds;
                // So, when CognitoIdentity authenticates a user, it doesn't actually hand us the IdentityID,
                // used by many of our other handlers. This is handled by some sly underhanded calls to AWS Cognito
                // API's by the SDK itself, automatically when the first AWS SDK request is made that requires our
                // security credentials. The identity is then injected directly into the credentials object.
                // If the first SDK call we make wants to use our IdentityID, we have a
                // chicken and egg problem on our hands. We resolve this problem by "priming" the AWS SDK by calling a
                // very innocuous API call that forces this behavior.
                const sts = new STS();
                sts.getCallerIdentity(function (err, data) {
                    console.log('UserLoginService: Successfully set the AWS credentials');
                    callback.cognitoCallback(null, result);
                });
            },
            onFailure: function (err) {
                callback.cognitoCallback(err.message, null);
            },
        });
    }

    async authenticateWithLDAP(username: string, password: string): Promise<void> {
        const headers = new HttpHeaders()
            // .set('Content-Type', 'application/x-www-form-urlencoded')
            // .set('upgrade-insecure-requests', '1')
            ;
        const options = { headers: headers };
        const apiUrlToUse = this.appConfig.getAPIUrlToUse();
        const url = `${apiUrlToUse}/auth/ldap`;
        return new Promise((resolve, reject) => {
            this.http.post<any>(url, { username, password }, options)
                .subscribe(
                    {
                        next: (response) => {
                            this.jwtService.getUserCredentials().handleJWTTokens(response.idToken, response.accessToken, response.refreshToken);
                        },
                        error: (error) => {
                            reject(error);
                        },
                        complete: () => {
                            resolve(undefined);
                        }
                    });
        });

    }

    forgotPassword(username: string, callback: CognitoCallback) {
        const userData = {
            Username: username,
            Pool: (this.jwtService.getUserCredentials() as UserCredentialsCognito).getUserPool()
        };
        const cognitoUser = new CognitoUser(userData);

        cognitoUser.forgotPassword({
            onSuccess: function () {

            },
            onFailure: function (err) {
                callback.cognitoCallback(err.message, null);
            },
            inputVerificationCode() {
                callback.cognitoCallback(null, null);
            }
        });
    }

    confirmNewPassword(email: string, verificationCode: string, password: string, callback: CognitoCallback) {
        const userData = {
            Username: email,
            Pool: (this.jwtService.getUserCredentials() as UserCredentialsCognito).getUserPool()
        };

        const cognitoUser = new CognitoUser(userData);

        cognitoUser.confirmPassword(verificationCode, password, {
            onSuccess: function () {
                callback.cognitoCallback(null, null);
            },
            onFailure: function (err) {
                callback.cognitoCallback(err.message, null);
            }
        });
    }



    async globalLogout(): Promise<string> {
        return this.jwtService.getUserCredentials().handleGlobalLogout();
    }

    async logoutAsync(): Promise<void> {
        // Stop the polling services
        this.serviceRegistry.pausePollingServices();
        console.log('UserLoginService: Logging out');

        await this.globalLogout();


    }

    // Deprecated
    // logout(callback: (message?: string, err?: Error) => void) {
    //     // Stop the polling services
    //     this.serviceRegistry.pausePollingServices();

    //     console.log('UserLoginService: Logging out');
    //     const cb = {
    //         onSuccess: (successMessage: string) => {
    //             callback(`UserLoginService: Globally signed out: ${successMessage}`, undefined);
    //         },
    //         onFailure: (err: Error) => {
    //             console.log(err);
    //             callback(undefined, err);
    //         }
    //     };
    //     const clientId = this.jwtService.cognitoUtil.getUserPool().getClientId();
    //     const currentUser = this.jwtService.cognitoUtil.getCurrentUser();

    //     currentUser.getSession((err, session) => {
    //         // Need to call this so globalSignout can find a session
    //         if (err) {
    //             callback(`Failed to get session for signout: ${err}`);
    //         } else {
    //             currentUser.globalSignOut(cb);
    //         }
    //     });
    //     currentUser.signOut(() => {
    //         console.log('Signed out');
    //     });
    //     if (AWS.config.credentials && AWS.config.credentials instanceof AWS.CognitoIdentityCredentials) {
    //         const cognitoCredentials: AWS.CognitoIdentityCredentials = AWS.config.credentials;
    //         cognitoCredentials.clearCachedId();
    //     }
    //     const lastUserKey = 'CognitoIdentityServiceProvider.' + clientId + '.LastAuthUser';
    //     window.localStorage.removeItem(lastUserKey);
    //     window.sessionStorage.removeItem(lastUserKey);
    // }

    isAuthenticated(callback: LoggedInCallback) {
        if (this.appConfig.getUseJSONData()) {
            console.log('=== Using local demo data ===');
            callback.isLoggedIn(undefined, true);
            return;
        }
        if (callback == null) {
            throw new Error('UserLoginService: Callback in isAuthenticated() cannot be null');
        }
        const userCredentials = this.jwtService.getUserCredentials();
        userCredentials.isAuthenticated()
            .then((isAuthenticated) => {
                callback.isLoggedIn(undefined, isAuthenticated);
            })
            .catch((err) => {
                callback.isLoggedIn(err, false);
            });

    }


    initiateLDAPLogin() {
        this.router.navigate(['/login'], {});
    }

    initateCognitoAuthLogin() {
        const regex = /\?code\=(.*)/;
        const match = regex.exec(window.location.href);
        const tenantInfo = this.appConfig.getTenantInfo();
        const cognitoDomainPrefix = tenantInfo.cognitoDomainPrefix;
        // const redirectUrl = 'https://localhost:4200';
        // const redirectUrl = 'https://development.liquitics.com';
        let redirectUrl = String(this.document.location.href);
        const codeIndex = redirectUrl.indexOf('?code=');
        if (codeIndex !== -1) {
            redirectUrl = redirectUrl.substring(0, codeIndex);
        }
        if (redirectUrl.endsWith('/#/')) {
            redirectUrl = redirectUrl.substring(0, redirectUrl.length - 3);
        } else if (redirectUrl.endsWith('/#')) {
            redirectUrl = redirectUrl.substring(0, redirectUrl.length - 2);
        } else if (redirectUrl.endsWith('/')) {
            redirectUrl = redirectUrl.substring(0, redirectUrl.length - 1);
        }


        const userCredentialsCognito = new UserCredentialsCognito(this.appConfig);
        const pool = userCredentialsCognito.getUserPool();
        if (!match || match.length <= 1) {
            // Didn't get forwarded from SAML redirect

            // tslint:disable-next-line:max-line-length
            const loginUrl = `https://${cognitoDomainPrefix}.auth.${tenantInfo.region}.amazoncognito.com/login?response_type=code&client_id=${pool.getClientId()}&&redirect_uri=${redirectUrl}`;
            this.document.location.href = loginUrl;
            // this.router.navigate(['/login']);
            return;
        }


        // //TRY
        // this.document.location.href = redirectUrl;
        // //TRY

        // setTimeout(() => {



        const headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('upgrade-insecure-requests', '1')
            ;
        // .set('Content-Type', 'application/json')
        const options = { headers: headers };
        let code = match[1];
        code = code.replace('#/', '');
        const body =
            'grant_type=authorization_code&' +
            'client_id=' + userCredentialsCognito.getUserPool().getClientId() + '&' +
            'code=' + code + '&' +
            'redirect_uri=' + redirectUrl;
        const tokenUrl = `https://${cognitoDomainPrefix}.auth.${tenantInfo.region}.amazoncognito.com/oauth2/token`;
        this.http.post<any>(tokenUrl, body, options)
            .toPromise()
            .then((tokens: any) => {
                const cognito = new AWS.CognitoIdentityServiceProvider();
                const getUserParam = {
                    AccessToken: tokens.access_token
                } as AWS.CognitoIdentityServiceProvider.Types.GetUserRequest
                return Promise.all([Promise.resolve(tokens), cognito.getUser(getUserParam).promise()]);
            })
            .then((results: any[]) => {
                const tokens = results[0];
                const cognitoUserResponse: AWS.CognitoIdentityServiceProvider.Types.GetUserResponse = results[1];
                const usernameAttribute = cognitoUserResponse.UserAttributes
                    .find((userAttribute: AWS.CognitoIdentityServiceProvider.Types.AttributeType) => {
                        return userAttribute.Name === 'email';
                    });
                if (!usernameAttribute) {
                    throw new Error('UserLoginService: Cognito response does not contain the email attribute. Please ensure SAML attribute mapping is set');
                }
                const username = usernameAttribute.Value;
                userCredentialsCognito.handleJWTTokens(tokens.id_token, tokens.access_token, tokens.refresh_token);
                // Do a logout to trigger a Global Logout and invalidate tokens in other sessions (ie other browsers)
                const crossSessionGlobalLogoutPerformed = window.sessionStorage.getItem('crossSessionGlobalLogoutPerformed');
                if (!crossSessionGlobalLogoutPerformed) {
                    this.globalLogout()
                        .then(() => {
                            window.sessionStorage.setItem('crossSessionGlobalLogoutPerformed', 'true');
                            this.document.location.href = this.document.location.href.substring(0, this.document.location.href.indexOf('?code='));
                        });
                } else {
                    this.document.location.href = this.document.location.href.substring(0, this.document.location.href.indexOf('?code='));
                }
                // this.cacheTokens(username, tokens.id_token, tokens.access_token, tokens.refresh_token);
                // this.router.navigate(['/login']);
                // this.router.navigate(['/']);
                return;
            });
        // }, 25);
    }



    // cacheTokens(username: string, idToken: string, accessToken: string, refreshToken: string) {
    //     const pool = this.jwtService.cognitoUtil.getUserPool();
    //     const keyPrefix = `CognitoIdentityServiceProvider.${pool.getClientId()}`;
    //     const idTokenKey = `${keyPrefix}.${username}.idToken`;
    //     const accessTokenKey = `${keyPrefix}.${username}.accessToken`;
    //     const refreshTokenKey = `${keyPrefix}.${username}.refreshToken`;
    //     const lastUserKey = `${keyPrefix}.LastAuthUser`;

    //     window.localStorage.setItem(idTokenKey, idToken);
    //     window.localStorage.setItem(accessTokenKey, accessToken);
    //     window.localStorage.setItem(refreshTokenKey, refreshToken);
    //     window.localStorage.setItem(lastUserKey, username);
    // }
}
